<template>
    <div>
        <Header></Header>
        <b-container class="login-container">
            <div class="login-form" @submit.prevent="RecoveryData">
                <form> 
                    <h4>{{'loginForgotHead' | localize}}</h4>
                    <input 
                        type="text" 
                        class="form-control my-2"
                        v-model="user_login"
                        placeholder="Логин"
                    >
                    <div 
                        class="form-description-error"
                        v-if="$v.user_login.$dirty && !$v.user_login.required"
                    >
                        {{'newAddressRequiredInput' | localize}}
                    </div>  
                    <div 
                        class="form-description-error"
                        v-if="$v.user_login.$dirty && !$v.user_login.minLength"
                    >
                        {{'userProfileMinSymbolsEight' | localize}}
                    </div>

                    <input 
                        type="text" 
                        class="form-control my-2"
                        v-model="user_email"
                        placeholder="email"
                    >              
                    <div 
                        class="form-description-error"
                        v-if="$v.user_email.$dirty && !$v.user_email.required"
                    >
                        {{'newAddressRequiredInput' | localize}}
                    </div>  
                    <div 
                        class="form-description-error"
                        v-if="$v.user_email.$dirty && !$v.user_email.email"
                    >
                        {{'registrationUserDataMailError' | localize}}
                    </div>  
                    <button
                        id="send-message"
                        class="btn-entry mt-3"
                        type="submit"
                    >
                        {{'loginForgotButton' | localize}}
                    </button>
                <div class="recovery-pass mx-auto mt-3"> 
                    <router-link
                        tag="strong"
                        :to="{name: 'Login'}"
                    >
                        {{'loginButton' | localize}}
                    </router-link>
                    
                </div>
                </form>
            </div>
        </b-container>  
    </div> 
</template>
<script>
import Header from '../components/Header'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength, email} from 'vuelidate/lib/validators'
export default {
    mixins: [validationMixin],
    data: ()=> ({
        user_login: '',
        user_email: '',
        user_info: null
    }),
    validations: {
        user_login: {required, minLength: minLength(8) },
        user_email: { required, email },
    },
    computed: mapGetters(['recoveryPassData', 'locale']),
    methods: {
        async RecoveryData(){
          if(this.$v.$invalid){
              this.$v.$touch()
          } else {
           const recovery_data = {
               login: this.user_login,
               mail: this.user_email
            }
            await this.$store.dispatch('RecoveryPass', recovery_data)
            if(this.recoveryPassData.msg === 'Нет такого пользователя !'){
              this.$messageLocalized('wrongData')
            } else if(this.recoveryPassData.msg === 'OK') {
              this.$messageLocalized('newPasswordSent')
            }
          }    
        }
    },
 components: { Header},
}
</script>
